export const environment = {
  production: true,
  apiBaseUrl: 'https://api.sandbox.cotral.com/tracelab/api/',
  keycloak: {
    authority: 'https://dev.kc.cotral.com/realms/Cotral',
    clientId: 'vizor',
  },
  salesforce: {
    prodBaseUrl: 'https://cotral.lightning.force.com/',
    sandboxBaseUrl: 'https://cotral--preprod.sandbox.my.salesforce.com/',
  },
  entitySets: {
    clients: 'Clients',
    orders: 'Commandes',
    orderLines: 'CommandeLignes',
    equipments: 'Equipements',
    equipmentNews: 'EquipementNews',
    etapesFab: 'EtapeFabs',
    postesFab: 'PosteFabs',
    commandeAdresses: 'CommandeAdresses',
    adresses: 'Adresses',
    colis: 'Colis',
    bonCommandes: 'BonCommandes',
    relCommandeLigneEquipementNews: 'RelCommandeLigneEquipementNews',
    relCommandeLigneColis: 'RelCommandeLigneColis',
    fab3DlotFichiers: 'Fab3DlotFichiers',
    relPamFab3DlotFichiers: 'RelPamFab3DlotFichiers',
  },
};
